<template>
  <div class="wlx-stu-manager-wrapper">
    <div class="u-school-manager-head stu-manager-head-con clearfix">
      <!-- <router-link :to="{name:'teaStandard'}" class="head-link-a">申请标准</router-link> -->
      <router-link :to="{name:'TeacherAudit'}" class="head-link-a" >讲师审核</router-link>
      <router-link :to="{name:'TeacherAppraiser'}" class="head-link-a">考评员审核</router-link>
      <router-link :to="{name:'teaPeiXunData'}" class="head-link-a">师资培训</router-link>
      <!-- <router-link :to="{name:'AuditCertificate'}" class="head-link-a">讲师考证审核</router-link>
      <router-link :to="{name:'TrainActivity'}" class="head-link-a">培训活动</router-link> -->
    </div>
    <div class="u-table-main" id="demo">
      <router-view></router-view>
    </div>
  </div>   
</template>

<script>
export default {
  data() {
    return {};
  },
  created(){
  }
};
</script>

<style lang="scss">
.wlx-stu-manager-wrapper {
  .stu-manager-head-con {
    text-align: left;
    .head-link-a {
      float: left;
      padding: 0 20px;
      text-align: center;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      color: #000;
    }
    .head-link-a:hover {
      color: #409eff;
    }
    .linkActive {
      border-bottom: 2px solid #409eff;
      color: #409eff;
    }
  }
}

</style>
